module.exports = __webpack_public_path__ + "img/home-icon.536dbd22.svg";